var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { serializePriceMode } from "../rna-fish/KitSerializer";
import { RnaCishEditableOrganism } from "./ProbeSetForm";
var RnaCishKitSerializer = /** @class */ (function () {
    function RnaCishKitSerializer(protocolType, config) {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setAmplifier = function (state) {
            _this.amplifierState = state;
        };
        this.setBuffers = function (state) {
            _this.buffersState = state;
        };
        this.setChromogenComponent = function (state) {
            _this.chromogenState = state;
        };
        this.setMiscComponent = function (state) {
            _this.miscComponentState = state;
        };
        this.serializeKit = function (comment, reasonForOther) {
            var probeSetComponent = null;
            if (_this.probeSetState) {
                var scale = _this.probeSetState.scale;
                var organism = _this.probeSetState.organism;
                var target = _this.probeSetState.target;
                if (_this.probeSetState.target.variantId != null) {
                    var id = _this.probeSetState.target.variantId;
                    probeSetComponent = {
                        _type: 'pro',
                        index: '1',
                        probeSet: {
                            _type: 'uiCatalogInput',
                            id: id,
                            hcrAmplifier: _this.probeSetState.hcrAmplifier.id,
                            probeLotNumber: _this.probeSetState.probeLotNumber,
                            customerOrganismName: organism.displayName(),
                            customerTargetName: target.name,
                            customerAccessionNum: target.accession,
                            customerSequence: target.targetMrnaSeq,
                            customerProbeSetSize: target.probeSetSize
                        },
                        scaleSlides: scale,
                        probeHybridizationAScaleSlides: _this.probeSetState.probeHybridizationAScale,
                        probeHybridizationBScaleSlides: _this.probeSetState.probeHybridizationBScale
                    };
                }
                else if (_this.probeSetState.organism.id !== RnaCishEditableOrganism.default().id) {
                    probeSetComponent = {
                        _type: 'pro',
                        index: '1',
                        probeSet: RnaCishKitSerializer.serializeCustomProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                        scaleSlides: scale,
                        probeHybridizationAScaleSlides: _this.probeSetState.probeHybridizationAScale,
                        probeHybridizationBScaleSlides: _this.probeSetState.probeHybridizationBScale
                    };
                }
                else {
                    probeSetComponent = {
                        _type: 'pro',
                        index: '1',
                        probeSet: RnaCishKitSerializer.serializeCustomProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                        scaleSlides: scale,
                        probeHybridizationAScaleSlides: _this.probeSetState.probeHybridizationAScale,
                        probeHybridizationBScaleSlides: _this.probeSetState.probeHybridizationBScale
                    };
                }
            }
            var amplifierComponent = null;
            if (_this.amplifierState) {
                amplifierComponent = RnaCishKitSerializer.serializeAmplifier(_this.amplifierState);
            }
            var buffersComponent = null;
            if (_this.buffersState) {
                buffersComponent = RnaCishKitSerializer.serializeBuffers(_this.buffersState, _this.protocolType);
            }
            var miscComponent = null;
            if (_this.miscComponentState) {
                miscComponent = RnaCishKitSerializer.serializeMiscComponent(_this.miscComponentState);
            }
            var chromogenComponent = null;
            if (_this.chromogenState) {
                chromogenComponent = RnaCishKitSerializer.serializeChromogenComponent(_this.chromogenState);
            }
            return {
                '_type': 'rna-cish',
                kit: {
                    protocolType: _this.protocolType.id,
                    config: _this.config,
                    probeSetComponent: probeSetComponent,
                    amplifierComponent: amplifierComponent,
                    buffersComponent: buffersComponent,
                    chromogenComponent: chromogenComponent,
                    miscComponent: miscComponent,
                    comment: comment,
                    reasonForOther: reasonForOther,
                    priceModes: {
                        probeSetMode: serializePriceMode(_this.probeSetState ? _this.probeSetState.customPrice : undefined),
                        amplifierMode: serializePriceMode(_this.amplifierState ? _this.amplifierState.customPrice : undefined),
                        buffersMode: serializePriceMode(_this.buffersState ? _this.buffersState.customPrice : undefined),
                        chromogenMode: serializePriceMode(_this.chromogenState ? _this.chromogenState.customPrice : undefined),
                        miscMode: serializePriceMode(_this.miscComponentState ? _this.miscComponentState.customPrice : undefined)
                    }
                }
            };
        };
        this.protocolType = protocolType;
        this.config = config;
    }
    RnaCishKitSerializer.serializeCustomProbeSet = function (organism, target, hcrAmplifier, probeLotNumber) {
        var jsonTarget = {
            name: target.name,
            accession: target.accession,
            targetMrnaSeq: target.targetMrnaSeq
        };
        if (organism.id !== RnaCishEditableOrganism.default().id) {
            return {
                '_type': 'uiLibraryOrganismCustomTargetInput',
                organism: {
                    id: organism.id,
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber
            };
        }
        else {
            return {
                '_type': 'uiOtherOrganismCustomTargetInput',
                organism: {
                    name: organism.name
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber
            };
        }
    };
    RnaCishKitSerializer.serializeBuffers = function (b, protocolType) {
        if (protocolType.id === "LEICA") {
            return {
                '_type': 'leica',
                'index': 1,
                'sampleTypeId': b.sampleType.id,
                'amplificationBufferScaleSlides': b.amplificationBufferScale,
                'blockingSolutionScaleSlides': b.blockingSolutionScale,
                'endogenousEnzymeScaleSlides': b.endogenousEnzymeScale,
                'preHybridizationScaleSlides': b.preHybridizationScale,
                'hrpQuencherScaleSlides': b.hrpQuencherScale,
                'bluingAgentScaleSlides': b.bluingAgentScale
            };
        }
        else if (protocolType.id === "ONCORE_PRO_X") {
            return {
                '_type': 'oncore',
                'index': 1,
                'sampleTypeId': b.sampleType.id,
                'amplificationBufferScaleSlides': b.amplificationBufferScale,
                'blockingSolutionScaleSlides': b.blockingSolutionScale,
                'endogenousEnzymeScaleSlides': b.endogenousEnzymeScale,
                'preHybridizationScaleSlides': b.preHybridizationScale,
                'hrpQuencherScaleSlides': b.hrpQuencherScale,
                'bluingAgentScaleSlides': b.bluingAgentScale
            };
        }
        else if (protocolType.id === "MANUAL") {
            return {
                '_type': 'manualPro',
                'index': 2,
                'sampleTypeId': b.sampleType.id,
                'amplificationBufferScaleSlides': b.amplificationBufferScale,
                'blockingSolutionScaleSlides': b.blockingSolutionScale,
                'endogenousEnzymeScaleSlides': b.endogenousEnzymeScale,
                'preHybridizationScaleSlides': b.preHybridizationScale,
                'hrpQuencherScaleSlides': b.hrpQuencherScale,
                'bluingAgentScaleSlides': b.bluingAgentScale
            };
        }
        return {
            '_type': 'roche',
            'index': 1,
            'sampleTypeId': b.sampleType.id,
            'amplificationBufferScaleSlides': b.amplificationBufferScale,
            'blockingSolutionScaleSlides': b.blockingSolutionScale,
            'endogenousEnzymeScaleSlides': b.endogenousEnzymeScale,
            'preHybridizationScaleSlides': b.preHybridizationScale,
            'hrpQuencherScaleSlides': b.hrpQuencherScale,
            'antigenRetrievalScaleSlides': b.antigenRetrievalScale,
            'dewaxScaleSlides': b.dewaxScale
        };
    };
    RnaCishKitSerializer.serializeAmplifier = function (a) {
        var _a;
        var serializedAmp = {};
        serializedAmp = __assign(__assign({}, serializedAmp), { '_type': 'pro', 'index': 1 });
        if (a.hcrAmplifier.id !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'amplifierId': a.hcrAmplifier.id });
        }
        if (a.hapten.id !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'haptenId': a.hapten.id });
        }
        if (a.antiHapten1.id !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'antiHapten1Id': a.antiHapten1.id });
        }
        if (a.tyramideHapten.id !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'tyramideHaptenId': a.tyramideHapten.id });
        }
        if (a.antiHapten2Ap != null && ((_a = a === null || a === void 0 ? void 0 : a.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.id) !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'antiHapten2ApId': a.antiHapten2Ap.id });
        }
        if (a.antiHapten2Hrp != null && a.antiHapten2Hrp.id !== "NONE") {
            serializedAmp = __assign(__assign({}, serializedAmp), { 'antiHapten2HrpId': a.antiHapten2Hrp.id });
        }
        serializedAmp = __assign(__assign({}, serializedAmp), { 'prefilled': a.prefilled, 'amplifierScaleSlides': a.amplifierScale, 'antiHapten1ScaleSlides': a.antiHapten1Scale, 'tyramideHaptenScaleSlides': a.tyramideHaptenScale, 'antiHapten2ApScaleSlides': a.antiHapten2ApScale, 'antiHapten2HrpScaleSlides': a.antiHapten2HrpScale });
        return serializedAmp;
    };
    RnaCishKitSerializer.serializeMiscComponent = function (misc) {
        return {
            description: misc.description,
            scaleInSlides: misc.scaleInSlides,
            scaleInMl: misc.scaleInMl
        };
    };
    RnaCishKitSerializer.serializeChromogenComponent = function (c) {
        if (c.chromogen.id === 'NONE' && c.chromogenBuffer.id === 'NONE' && c.hematoxylinScaleSlides === 0) {
            return null;
        }
        else {
            var serializedChromogen = {};
            serializedChromogen = __assign(__assign({}, serializedChromogen), { 'index': 1 });
            if (c.chromogen.id !== 'NONE') {
                serializedChromogen = __assign(__assign({}, serializedChromogen), { 'chromogenId': c.chromogen.id, 'chromogenScaleSlides': c.chromogenScaleSlides });
            }
            else {
                serializedChromogen = __assign(__assign({}, serializedChromogen), { 'chromogenScaleSlides': 0 });
            }
            if (c.chromogenBuffer.id !== 'NONE') {
                serializedChromogen = __assign(__assign({}, serializedChromogen), { 'chromogenBufferId': c.chromogenBuffer.id, 'chromogenBufferScaleSlides': c.chromogenBufferScaleSlides });
            }
            else {
                serializedChromogen = __assign(__assign({}, serializedChromogen), { 'chromogenBufferScaleSlides': 0 });
            }
            serializedChromogen = __assign(__assign({}, serializedChromogen), { 'hematoxylinScaleSlides': c.hematoxylinScaleSlides });
            return serializedChromogen;
        }
    };
    return RnaCishKitSerializer;
}());
export default RnaCishKitSerializer;
//# sourceMappingURL=KitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/KitSerializer.js
// module id = 551
// module chunks = 0